import axios from '@/shared/utils/axios-init';


const initialState = {
  blogItemsData: {},
  blogItem: {},
};


const getters = {
  getBlogItemsData(state) {
    return state.blogItemsData;
  },
  getBlogItem(state) {
    return state.blogItem;
  },
};

const mutations = {
  setBlogItemsData(state, data) {
    state.blogItemsData = data;
  },
  setBlogItem(state, data) {
    state.blogItem = data;
  },
};

const actions = {
  async fetchBlogItemsData({ commit }, credentials) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const lang = localStorage.getItem('language');
      const data = await axios.post('/articles', JSON.stringify({ page: credentials.page, lang }), { headers: { Authorization: `Bearer ${token}` } });
      const blogItems = data.data.articles;

      commit('setBlogItemsData', blogItems);

      return data;
    } catch (error) {
      return error.response;
    }
  },
  async getBlogItemData({ commit }, { slug }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const lang = localStorage.getItem('language');
      const data = await axios.post('/article', JSON.stringify({ slug, lang }), { headers: { Authorization: `Bearer ${token}` } });
      const blogItem = data.data.article;

      commit('setBlogItem', blogItem);

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Info/modules/blog.js